import { render } from "./WishList.vue?vue&type=template&id=7c44705a&scoped=true"
import script from "./WishList.vue?vue&type=script&lang=js"
export * from "./WishList.vue?vue&type=script&lang=js"

import "./WishList.vue?vue&type=style&index=0&id=7c44705a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c44705a"]])

export default __exports__